import { UnaryExpression } from "./abstract.unary.expression";
import { FunctionExpression } from "./abstract.functionExpression";
import { ToLowerFunction } from "./toLowerFunction";

export class EndsWithFunction extends FunctionExpression
{
    constructor(field: string | UnaryExpression, value: string)
    {
        super("endswith", new ToLowerFunction(field), [value]);
    }
}
